module.exports = __webpack_public_path__ + "img/upd_template.9ccb59f6.png";